module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "IMG_0008.683f993a.jpg" + "?" + Date.now();